export enum ColumnId {
    LEFT = 'left',
    WINNING_PERCENTAGE = 'winning-percentage',
    ASSESSED_COMMITS = 'assessed-commits',
    DISTRIBUTION = 'distribution',
    EXCLUDED_COMMITS = 'excluded-commits',
}
